// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3KvtS","validationTips":"StatementDescriptor_validationTips__2t6xa"};